import { render, staticRenderFns } from "./Ordc01View.vue?vue&type=template&id=514c05fc&scoped=true&"
import script from "./Ordc01View.vue?vue&type=script&lang=ts&"
export * from "./Ordc01View.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514c05fc",
  null
  
)

export default component.exports